import { useCallback, useContext, useEffect } from 'react'
import loadable from '@loadable/component'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { canAccessExperimentPanel } from 'lib/experiments/experimentPanelAccess'

const ExperimentControlPanel = loadable(() => import('./ExperimentControlPanel'))

function ExperimentControlPanelLauncher() {
  const showModal = useContext(ModalContext)
  const canAccess = useAppSelector(canAccessExperimentPanel)
  const openExperimentPanel = useCallback(() => {
    showModal(<ExperimentControlPanel />)
  }, [showModal])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!canAccess || !event.shiftKey || (!event.metaKey && !event.ctrlKey) || event.code !== 'KeyE') {
        return
      }

      event.preventDefault()
      openExperimentPanel()
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [canAccess, openExperimentPanel])

  return null
}

export default ExperimentControlPanelLauncher
